import { RootState } from 'editor/src/store/index';

const getSpreadGroups = (state: RootState) => state.design.designData?.spread_groups;

export default getSpreadGroups;
